export namespace CommonConstants {
  export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

  export const FooterText = '© 2021-22 All rights reserved.';
  export const passphrase = 'IC';
  export const authorizationKey = 'icToken';
  export const clientKey = 'iClient';
  export const menuKey = 'iCart';
  export const mobileKey = 'iMobile';
  export const password = 'ishant@123'

  export enum SortDirection {
    None = 0,
    Asc = 1,
    Desc = 2,
  }
  export enum FilterOperator {
    NOFILTER = 1,
    EQUALTO,
    NOTEQUALTO,
    GREATERTHAN,
    LESSTHAN,
    CONTAINS,
    STARTSWITH,
    ENDSWITH,
    BETWEEN,
  }

  export enum CheckoutSteps {
    ReviewCart = 1,
    Login = 2,
    Contact = 3,
    Billing = 4,
  }

  export enum ActiveStatus {
    InActive = 0,
    Active = 1,
  }
  export enum Role {
    Administrator = 1,
    Restaurant = 2,
    Outlet = 3,
    Manager = 4,
    Customer = 5,
  }
  export enum DiscountType {
    Percentage = 1,
    FreeItem = 2,
    Fixed = 3
  }
  export enum RequestStatus {
    Accept = 0,
  }
  export enum DeliveryType {
    Delivery = 1,
    Pickup = 2,
    Both = 3,
    Table = 4,
    Kiosk = 5,
  }
  export enum MenuLevel {
    MenuItem = 1,
    SubCategory = 2,
    Category = 3,
  }
  export enum AddonSelectionType {
    Radio = 1,
    CheckBox = 2,
  }
  export enum OrderType {
    Now = 1,
    Later = 2,
  }
  export enum TipType {
    Percentage = 1,
    Fixed = 2,
  }
  export enum FeeType {
    Percentage = 1,
    Fixed = 2,
  }
  export enum FeeCalculationType {
    BeforeDiscount = 1,
    AfterDiscount = 2,
    NetAmount = 3,
  }
  export enum TransactionType {
    Credit = 1,
    Debit = 2,
  }
  export enum PaymentType {
    Cash = 1,
    Credit = 2,
  }
  export enum PasswordResetType {
    VerificationLink = 1,
    VerificationCode = 2,
    ResetPassword = 3,
  }
  export enum PaymentStatus {
    Initiated = 1,
    Failed = 2,
    Pending = 3,
    Accept = 4,
  }
  export enum PaymentMode {
    CashPayment = 1,
    Paypal = 2,
    SquareUp = 3,
    CardConnect = 4,
    Authorize = 5,
    AuthorizeV2 = 6,
  }
  export enum OrderStatus {
    Processing = 0,
    Delivered = 1,
    Rejected = 2,
  }
  export enum OrderSource {
    Android = 1,
    Web = 2,
    Ios = 3,
  }
  export enum GiftCardType {
    Ecard = 1,
    Physical = 2,
  }
  export enum BuyType {
    Self = 1,
    Gift = 2,
  }
  export enum CouponType {
    Percentage = 1,
    Fixed = 2,
  }
  export enum ProductDeliveryMode {
    Email = 1,
    Sms = 2,
    Both = 3,
  }
  export enum MemberType {
    Member = 1,
    Guest = 2,
    Both = 3,
  }
  export enum CouponLimitType {
    NoLimit = 1,
    Global = 2,
    User = 3,
  }
}
